// extracted by mini-css-extract-plugin
export var gif = "_iq-0";